import React, { useEffect } from 'react';
import { Spin } from 'antd';

const OAuthCallback = () => {
  useEffect(() => {
    const handleCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
     const error = urlParams.get('error');
      
      if (error) {
        window.location.href = '/client/integrations?error=' + encodeURIComponent(error);
        return;
      }
      
      if (!code) {
        window.location.href = '/client/integrations?error=no_code';
        return;
      }

      try {
        const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
        
        // Extract provider from the URL path based on the actual routes
        if (window.location.pathname.includes('google-ads')) {
          // Use the dedicated Google Ads callback endpoint
          const callbackUrl = `${backendUrl}/api/integrations/google-ads/callback${window.location.search}`;
          window.location.href = callbackUrl;
          return;
        } else if (window.location.pathname.includes('meta') || window.location.pathname.includes('facebook')) {
          // Use the dedicated Meta/Facebook callback endpoint  
          const callbackUrl = `${backendUrl}/api/integrations/meta/callback${window.location.search}`;
          window.location.href = callbackUrl;
          return;
        }
        
        // Fallback for any other providers
        window.location.href = '/client/integrations?error=unsupported_provider';
      } catch (err) {
        console.error('OAuth callback error:', err);
        window.location.href = '/client/integrations?error=network_error';
      }
    };

    handleCallback();
  }, []);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      gap: '16px'
    }}>
      <Spin size="large" />
      <div>Completing authentication...</div>
    </div>
  );
};

export default OAuthCallback;
